/**
 * Debug helper utility
 * Handles debug-related functionality for scenes
 */

import type { SceneData } from '../types'
import { isDebugModeEnabled } from '../../debug'

export interface DebugHelperContext {
  container: HTMLDivElement
  data: SceneData
  sceneIndex?: number
  onSceneDebugClick?: (sceneIndex: number) => void
}

/**
 * Append scene number debug element if debug mode is enabled
 */
export function appendSceneNumberDebug(context: DebugHelperContext): void {
  const { container, data, sceneIndex, onSceneDebugClick } = context

  if (!isDebugModeEnabled()) {
    return
  }

  const sceneNumber = document.createElement('div')
  sceneNumber.className = 'scene-number-debug'
  sceneNumber.textContent = data.id

  if (sceneIndex !== undefined) {
    sceneNumber.setAttribute('aria-label', `Načíst stav hry: ${data.id}`)
    sceneNumber.addEventListener('click', () => {
      if (sceneIndex !== undefined && onSceneDebugClick) {
        onSceneDebugClick(sceneIndex)
      }
    })
  }

  container.appendChild(sceneNumber)
}
